export default __webpack_public_path__ + "maps-examples-map-snapshotter-thumbnail-960-9217ff28bfb6e19077cdb88a27dd4fe8.webp";